import script from "./UAddUniversal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UAddUniversal.vue?vue&type=script&setup=true&lang=ts"

import "./UAddUniversal.vue?vue&type=style&index=0&id=8a2402f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2402f0"]])

export default __exports__